export default __webpack_public_path__ + "static/media/second.99e631bf.png";